import { motion } from "framer-motion";

export const LogoMark = ({ className = "h-8 w-auto", light = false, draw = false }) => {
  const second = light ? "#F6F4EE" : "#2B2E30";
  const P = draw ? motion.rect : "rect";
  const anim = (d) => (draw ? { initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: { duration: 1.6, delay: d, ease: [0.65, 0, 0.35, 1] } } : {});
  return (
    <svg viewBox="0 0 120 76" className={className} aria-hidden="true">
      <defs><clipPath id={`lc-${light}`}><rect x="50" y="8" width="20" height="24" /></clipPath></defs>
      <P x="20" y="20" width="36" height="36" rx="5" transform="rotate(45 38 38)" fill="none" stroke="#45A9A0" strokeWidth="7" {...anim(0.1)} />
      <P x="64" y="20" width="36" height="36" rx="5" transform="rotate(45 82 38)" fill="none" stroke={second} strokeWidth="7" {...anim(0.3)} />
      <rect x="20" y="20" width="36" height="36" rx="5" transform="rotate(45 38 38)" fill="none" stroke="#45A9A0" strokeWidth="7" clipPath={`url(#lc-${light})`} />
    </svg>
  );
};

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="h-7 w-auto" light={light} />
    <span className={`font-display text-[1.35rem] font-medium tracking-tight ${light ? "text-[#F6F4EE]" : "text-[#12202B]"}`}>translinked</span>
  </span>
);
